module.exports = __webpack_public_path__ + "img/7.ec2abe6f.jpg";